export default __webpack_public_path__ + "static/media/Duotone.ed297201.jpg";